export default __webpack_public_path__ + "static/media/324.e0094ab9.svg";